import PropTypes from 'prop-types';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import Icon from '../common/Icon';

const ErrorsSection = ({
    isAppDefinitionValid,
    validationErrorMessage,
    validationErrorDownload,
    validationErrorDetails,
}) => {
    const [validationErrorsBlobUrl, setValidationErrorsBlobUrl] = useState(null);
    const didMountRef = useRef(false);
    useEffect(() => {
        if (didMountRef.current) {
            if (validationErrorDownload) {
                const blob = new Blob([validationErrorDetails], { type: 'text/plain' });
                const objectURL = window.URL.createObjectURL(blob);
                setValidationErrorsBlobUrl(objectURL);
            }
            if (!validationErrorDownload) {
                window.URL.revokeObjectURL(validationErrorsBlobUrl);
                setValidationErrorsBlobUrl(null);
            }
        } else {
            didMountRef.current = true;
        }
    }, [validationErrorDownload]);

    return (
        <div className="sideloaded-errors-section">
            {isAppDefinitionValid ? null : (
                <>
                    <p className="sideloaded-error-message">{validationErrorMessage}</p>
                    {validationErrorDownload ? (
                        <a
                            href={validationErrorsBlobUrl}
                            download="validationErrors"
                            className="sg-button-link sideloaded-download-report-btn"
                        >
                            <Icon alias="link" />
                            Download&nbsp;report
                        </a>
                    ) : null}
                </>
            )}
        </div>
    );
};

ErrorsSection.propTypes = {
    isAppDefinitionValid: PropTypes.bool.isRequired,
    validationErrorMessage: PropTypes.string,
    validationErrorDownload: PropTypes.bool.isRequired,
    validationErrorDetails: PropTypes.string,
};

export default ErrorsSection;
